module.exports = __webpack_public_path__ + "img/icono-sugerencia.8af1c17b.svg";